

// class Core {
//     constructor() {
//         this.currentTimeout = null;
//     };
//     wait(timeout) {
//         if (this.currentTimeout) {
//             clearTimeout(this.currentTimeout);
//         };
//         return new Promise(resolve => {
//             this.currentTimeout = setTimeout(resolve, timeout);
//         });
//     };
// };

window.addEventListener("load", function () {
    
});
